// EDAP EVENTS
export const ONEKEY_BURN_PRESENTED = 'onekey_burncashmessage.presented';

// ACTION LOCATIONS
export const PRICE_DETAILS_NEW_LOCATION_MWEB = 'stay_ui_price_details_new_mweb';
export const PRICE_DETAILS_NEW_LOCATION = 'stay_ui_price_details_new';
export const PRICE_DETAILS_LOCATION_MWEB = 'stay_ui_price_details_mweb';
export const PRICE_DETAILS_LOCATION = 'stay_ui_price_details';
